import inViewModule from 'angular-inview';
import register from '@kpsys/angularjs-register';

import KpPdfPageComponent from './kp-pdf-page/kp-pdf-page.component';
import KpPdfScrollingPageComponent from './kp-scrolling-page/kp-pdf-scrolling-page.component';
import {KpPdfScrollingDocumentComponent} from './kp-pdf-scrolling-document/kp-pdf-scrolling-document.component';
import KpPdfDocumentComponent from './kp-pdf-document/kp-pdf-document.component';
import KpPdfDataComponent from './kp-pdf-data/kp-pdf-data.component';
import KpPdfViewerComponent from './kp-pdf-viewer/kp-pdf-viewer.component';
import KpPdfViewerControlPanelComponent from './kp-pdf-viewer-control-panel/kp-pdf-viewer-control-panel.component';
import KpPdfViewerControlPanelService from './kp-pdf-viewer-control-panel/kp-pdf-viewer-control-panel.service';
import {buildCommandDirective, KpPdfViewerControlPanelCurrentPage} from './kp-pdf-viewer-control-panel/kp-pdf-command-directives';

export default register('pdf-viewer', [inViewModule])
    .constant('PDF_BUFFER_LENGTH', 10)
    .constant('PIXEL_RATIO', window.devicePixelRatio || 1)
    .constant('VIEWPORT_RATIO', 0.98)
    .service(KpPdfViewerControlPanelService.serviceName, KpPdfViewerControlPanelService)
    .component(KpPdfPageComponent.componentName, KpPdfPageComponent)
    .component(KpPdfScrollingPageComponent.componentName, KpPdfScrollingPageComponent)
    .component(KpPdfScrollingDocumentComponent.componentName, KpPdfScrollingDocumentComponent)
    .component(KpPdfDocumentComponent.componentName, KpPdfDocumentComponent)
    .component(KpPdfDataComponent.componentName, KpPdfDataComponent)
    .component(KpPdfViewerComponent.componentName, KpPdfViewerComponent)
    .component(KpPdfViewerControlPanelComponent.componentName, KpPdfViewerControlPanelComponent)
    .directive('kpPdfViewerControlPanelZoomIn', buildCommandDirective('zoomIn'))
    .directive('kpPdfViewerControlPanelZoomOut', buildCommandDirective('zoomOut'))
    .directive('kpPdfViewerControlPanelFitAuto', buildCommandDirective('fitAuto'))
    .directive('kpPdfViewerControlPanelFitWidth', buildCommandDirective('fitWidth'))
    .directive(KpPdfViewerControlPanelCurrentPage.directiveName, KpPdfViewerControlPanelCurrentPage)
    .name();
